module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-9.c0082f1e.png";